<template>
  <div class="planComMainPage" v-loading="$store.state.user.loadingState">
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <MaintenancePlanForm v-if="sourceType == 'MAINTENANCE'" @getFormBtn="getFormBtn" @handleAddEdit="handleAddEdit" />
        <PatrolPlanForm v-if="sourceType == 'INSPECTION'" @getFormBtn="getFormBtn" @handleAddEdit="handleAddEdit" />
      </div>
      <div class="tabCardBox">
        <div class="orderCardItem">
          <MaintenancePlanTable :tabHead="tabHead" :tableData="tableData" @sentIndexFn="$parent.sentIndexFn"
            @handleAddEdit="handleAddEdit" />
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[10, 30, 50, 100]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
            :total="page.total" style="margin-top: 10px; text-align: right">
          </el-pagination>
        </div>
      </div>
      <!-- 新增/编辑保养计划 -->
      <AddEditPlan :activeItem="activeItem" v-if="addPlanPopup && $route.path === '/maintainPlan'" />

      <!-- 新增/修改巡检计划 -->
      <AddPatrolPlan v-if="addPlanPopup && $route.path === '/patrolPlan'" :clickRow="activeItem" />

    </div>
  </div>
</template>

<script>
import api from "@/api";
import MaintenancePlanForm from "./mainPage/MaintenancePlanForm";
import PatrolPlanForm from "./mainPage/PatrolPlanForm";
import MaintenancePlanTable from "./mainPage/MaintenancePlanTable";
import AddEditPlan from "@/components/houqinguanli/baoyangguanli/AddEditPlan";
import AddPatrolPlan from "@/components/houqinguanli/xunjianguanli/AddPatrolPlan";
import { dateFtt, exportExcelFun, matchingWeek } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  components: {
    MaintenancePlanForm,
    PatrolPlanForm,
    MaintenancePlanTable,
    AddEditPlan,
    AddPatrolPlan,
  },
  data() {
    return {
      sourceType: "",
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      tabHead: [],
      tableData: [],
      searchTxt: "", //搜索字段
      typeValue: "", //保养计划中计划执行时间选择项
      addPlanPopup: false, //新增/编辑保养
      activeItem: {}, //点击编辑项
      planId: "",
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getFormBtn(data) {
      this.searchTxt = data.searchTxt;
      this.planId = data.planId;
      if (this.sourceType == "MAINTENANCE") {
        this.typeValue = data.typeValue;
      }
      this.handleSizeChange(10);
    },
    getTableHead() {
      if (this.sourceType == "MAINTENANCE") {
        //保养
        this.tabHead = [
          { label: "计划名称", prop: "name" },
          { label: "关联设备数", prop: "deviceSize" },
          { label: "计划执行时间", prop: "planTime" },
          { label: "最近执行时间", prop: "lastTime" },
          { label: "计划周期", prop: "planPeriod" },
          { label: "本年度执行次数", prop: "yearCount" },
          { label: "累计执行次数", prop: "totalCount" },
          { label: "计划执行人员", prop: "handleUser" },
        ];
      } else if (this.sourceType == "INSPECTION") {
        // 巡检
        this.tabHead = [
          { label: "巡检计划", prop: "name" },
          { label: "巡检线路", prop: "routeName" },
          { label: "巡检类型", prop: "type" },
          { label: "循环周期", prop: "cycle" },
          { label: "限时", prop: "planTimeList" },
          { label: "本月巡检次数", prop: "monthCount" },
          { label: "本年巡检次数", prop: "yearCount" },
          { label: "最近巡检时间", prop: "lastTime" },
          { label: "巡检人", prop: "handleUser" },
          { label: "备注", prop: "remark" },
        ];
      }
    },
    async getList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      if (this.sourceType == "MAINTENANCE") {
        this.getMaintainPlan();
      } else if (this.sourceType == "INSPECTION") {
        this.getPatrolPlan();
      }
    },
    // 获取保养计划列表
    async getMaintainPlan() {
      let res = await api.maintenancePlanGetList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        name: this.searchTxt,
        dateRange: this.typeValue,
        sourceType: this.sourceType,
        planId: this.planId,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.planPeriod = v.period ? `${v.period}天/次` : "";
          v.planTime = `${dateFtt(
            "yyyy-MM-dd",
            new Date(v.startTime)
          )}-${dateFtt("yyyy-MM-dd", new Date(v.endTime))}`;
          v.lastTime = v.lastExecutionTime
            ? dateFtt("yyyy-MM-dd", new Date(v.lastExecutionTime))
            : "-";
          v.handleUser = v.handlersInfo
            ?.map((item) => {
              return item.name;
            })
            .join(",");
          v.open = v.state == "ENABLE" ? true : false;
        });
        this.page.total = res.data.data.totalElements;
      }
    },
    // 获取巡检计划列表
    async getPatrolPlan() {
      let res = await api.patrolPlanGetList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        name: this.searchTxt,
        sourceType: "INSPECTION",
        planId: this.planId,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data.data;
        this.page.total = res.data.data.totalElements;
        this.tableData.forEach((v) => {
          v.open = v.state == "ENABLE" ? true : false;
          v.type = v.planType == "CYCLE" ? "循环计划" : "临时计划";
          v.cycle =
            v.planCycle == "DAY"
              ? "每天"
              : v.planCycle == "WEEK"
                ? "每周"
                : v.planCycle == "MONTH"
                  ? "每月"
                  : "-";
          v.lastTime = v.maxTime
            ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.maxTime))
            : "";
          v.handleUser = v.handlersInfo
            .map((item) => {
              return item.name;
            })
            .join(",");
          let str = "";
          if (v.planCycle == "WEEK") {
            v.planTimeLimits.map((v) => {
              return (str += `${matchingWeek(v.typeBeginTime)} ${v.beginTime
                } - ${matchingWeek(v.typeEndTime)} ${v.endTime};`);
            });
          } else {
            v.planTimeLimits.map((v) => {
              return (str += `${v.typeBeginTime} ${v.beginTime} - ${v.typeEndTime} ${v.endTime};`);
            });
          }
          v.planTimeList = str;
        });
      }
    },
    handleAddEdit(data) {
      this.activeItem = data;
      this.addPlanPopup = true;
    },
    exportExcel() {
      exportFile.xlsxFile(
        XLSX,
        this.$route.path == "/maintainPlan" ? "保养计划" : "巡检计划",
        {
          excel: exportExcelFun(this.tabHead, this.tableData),
        }
      );
    },
  },
  created() {
    this.sourceType =
      this.$route.path == "/maintainPlan" ? "MAINTENANCE" : "INSPECTION";
    this.getTableHead();
  },
};
</script>

<style lang="scss" scoped>
.planComMainPage {
  width: 100%;
  height: 100%;
  @include setFlexCenter;

  .sheetsContent {
    width: 98%;
    height: 100%;

    ::v-deep .el-select .el-input__inner {
      vertical-align: bottom !important;
    }

    ::v-deep .el-input--suffix .el-input__inner {
      vertical-align: bottom !important;
    }
  }
}
</style>